import { ConsolidatedCoinData } from "@shared/types";
import { DISPLAY_CURRENCIES, EXCHANGES } from "@shared/common/constants";
import { useSelector } from "react-redux";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import { useMemo } from "react";

interface UseCoinCardProps {
  coinData?: ConsolidatedCoinData;
}

const useCoinCard = ({ coinData: propsCoinData }: UseCoinCardProps) => {
  const displayCurrency = useSelector(selectDisplayCurrency);

  const getExchangeByPriority = (exchanges: string[]) => {
    for (let exchange of EXCHANGE_PRIORITY) {
      if (exchanges.includes(exchange)) return exchange;
    }
  };

  const getAsset = (coinData?: ConsolidatedCoinData) =>
    coinData?.symbol.split("/")[0];

  const getExchange = (coinData?: ConsolidatedCoinData) => {
    if (coinData)
      return (
        getExchangeByPriority(coinData.exchanges) || coinData.exchanges?.[0]
      );
  };

  const getInitialPrice = (coinData?: ConsolidatedCoinData) => {
    return displayCurrency === DISPLAY_CURRENCIES.BTC
      ? coinData?.btc_price
      : coinData?.usd_price;
  };

  const coinData = useMemo(() => {
    return {
      asset: getAsset(propsCoinData),
      exchange: getExchange(propsCoinData),
      initialPrice: getInitialPrice(propsCoinData),
    };
  }, [propsCoinData]);

  return {
    coinData,
    getAsset,
    getExchange,
    getInitialPrice,
  };
};

export default useCoinCard;

const EXCHANGE_PRIORITY = [
  EXCHANGES.BINANCE,
  EXCHANGES.BINANCE_FUTURES,
  EXCHANGES.BYBIT_USDT,
  EXCHANGES.BYBIT_SPOT,
  EXCHANGES.KUCOIN,
  EXCHANGES.KUCOIN_FUTURES,
  EXCHANGES.FTX_FUTURES,
  EXCHANGES.FTX,
  EXCHANGES.BINANCE_COIN_FUTURES,
  EXCHANGES.BITMEX,
  EXCHANGES.HUOBI,
  EXCHANGES.BITTREX,
];
